<template>
    <div class="study-payment-status">
        <h1 v-if="subscription.price > 0">Вы получили абонемент по направлению «{{ studyProduct.name }}»</h1>
        <h1 v-else>Вы получили один пробный урок по направлению «{{ studyProduct.name }}»</h1>

        <h3
                :data-id="subscription.idsubscription"
                data-model="subscription"
                :data-price="subscription.price"
                data-action="payment-succeeded"
                class="data-subscription-payment-status"
        >Чем можно заняться уже сейчас? </h3>

        <p><span class="strong-black">Всю информацию мы продублировали в приветственном письме, которое только что отправили вам на почту.</span>
        </p>

        <p>
            Найти <span v-if="subscription.price > 0">первое</span><span v-else>пробное</span> занятие вы можете в
            личном кабинете <a href="/home-teacher/user/profile/courses">на вкладке &laquo;Курсы&raquo;</a>.</p>

        <p>Просто нажмите &laquo;Посмотреть курс - Перейти&raquo; и приступайте к уроку!&nbsp;</p>

        <p>На странице занятия вам доступны дополнительные материалы, которые мы советуем распечатать заранее. Так урок
            пройдёт ещё эффективнее.</p>

        <p>После занятия не забудьте использовать тесты и тренажёры. Они помогут закрепить полученные знания!</p>

        <h3 v-if="studyProduct.idstudyproduct == 1">Ещё больше интересного…</h3>

        <p v-if="studyProduct.idstudyproduct == 1">Вы также можете получить три дня бесплатного доступа к групповым
            занятиям!</p>

        <p v-if="studyProduct.idstudyproduct == 1">Для этого просто перейдите <a href="/home-teacher/schedule/lang/en">по ссылке</a>, выберете подходящую группу, абонемент
            &laquo;3 пробных дня&raquo; и запишитесь!</p>

        <p v-if="studyProduct.idstudyproduct == 1">Доступ к занятиям появится в вашем личном кабинете на вкладке &laquo;Расписание&raquo;.</p>

        <h3>Что дальше?</h3>

        <p>Если вы ещё не общались с нашим менеджером, то он свяжется с вами в
            ближайшее время, расскажет всё о работе платформы и ответит на интересующие вопросы.</p>

        <h3>Как с вами связаться?</h3>

        <p>Вы также можете связаться с нами самостоятельно. </p>

        <p>Наша служба поддержки работает с понедельника по пятницу, с 9:00 до
            19:00 по Московскому времени.</p>

        <p>Написать нам можно через <a href="/home-teacher/entry">форму обратной связи</a>.</p>


        <div style="text-align: center;"
             :data-id="studyProduct.idstudyproduct"
             data-model="studyProduct"
             data-action="payment-succeeded"
             class="mt-5 data-studyProduct-payment-status"
        >
            <a :href="`/${studyProduct.slug}.html#go`"
               style="text-decoration: none; font-size:21px; width: 400px;height: 73px;line-height: 73px; font-weight: bold; text-align: center; color: #009700; background: #BAF2BB; border-radius: 22px; display: inline-block;"
               target="_blank">Купить направление</a>
        </div>

    </div>
</template>

<script>
    export default {
        name: "StudyPaymentStatus",
        props: {
            studyProduct: Object,
            subscription: Object,
        },

    }
</script>

<style>
    .study-payment-status p, .study-payment-status ul, .study-payment-status li {
        font-family: "Manrope Book";
        font-size: 16px;
        line-height: 16px;
    }

    .study-payment-status p a {
        text-decoration: underline;
        color: black;
    }

    .study-payment-status {
        text-align: left;
        color: black;
    }

    .study-payment-status h1 {
        font-size: 24px;
        color: #000;
        line-height: 28px;
        margin-top: 62px;
        margin-bottom: 32px;
        font-family: Manrope Bold;
    }

    .study-payment-status h3 {
        font-size: 20px;
        line-height: 36px;
        color: #000;
        margin-top: 18px;
        margin-bottom: 16px;
        font-family: Manrope Bold;
    }

</style>
